import { LocationSummary } from "../../constants/action-constants/LocationSummaryActionConstants";

// initial state
const initialState = {
  // location summary
  dataLoading: false,
  data: "",
  dataErr: "",

  // landmark nearby modal
  openLandmarkNearbyModal: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LocationSummary.GET_LOCATION_SUMMARY:
      return {
        ...state,
        dataLoading: true,
      };

    case LocationSummary.GET_LOCATION_SUMMARY_SUCCESS: {
      return {
        ...state,
        data: action.data,
        dataLoading: false,
      };
    }

    case LocationSummary.GET_LOCATION_SUMMARY_FAILURE: {
      return {
        ...state,
        dataLoading: false,
        dataErr: action.payload,
      };
    }

    case LocationSummary.RESET_LOCATION_SUMMARY: {
      return initialState;
    }

    case LocationSummary.OPEN_LANDMARK_NEARBY_MODAL:
      return {
        ...state,
        openLandmarkNearbyModal: true,
      };
    case LocationSummary.CLOSE_LANDMARK_NEARBY_MODAL:
      return {
        ...state,
        openLandmarkNearbyModal: false,
      };

    default:
      return state;
  }
};
